"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../utils");
var SpecialCategory = function SpecialCategory(props) {
  var children = props.children,
    specials = props.specials;
  return (0, _utils.getCategoryItems)(specials).map(function (data) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: data.id
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      className: "special-category"
    }, /*#__PURE__*/_react["default"].createElement("span", null, data.name)), children(data));
  });
};
SpecialCategory.propTypes = {
  specials: _propTypes["default"].shape({
    schedules: _propTypes["default"].array,
    categories: _propTypes["default"].array,
    items: _propTypes["default"].array,
    modifierSets: _propTypes["default"].array,
    modifiers: _propTypes["default"].array
  }).isRequired
};
var _default = SpecialCategory;
exports["default"] = _default;